import React from "react";
import { Box, Typography } from "@mui/material";
import Setting from "../pages/settings/Setting";

const SettingContainer = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3, minHeight: "85vh" }}>
      <Typography
        variant="h3"
        sx={{ mb: 1, fontWeight: "bold", color: "#333" }}
      >
        Welcome to Settings
      </Typography>
      <Typography variant="h6" sx={{ mb: 8, color: "#666" }}>
        Here you can manage your data backup, so it never gets lots.
      </Typography>

      <Setting />
    </Box>
  );
};

export default SettingContainer;
